import axios from 'axios';

// Action Types
export const FETCH_PLAN_CONTENT_REQUEST = 'FETCH_PLAN_CONTENT_REQUEST';
export const FETCH_PLAN_CONTENT_SUCCESS = 'FETCH_PLAN_CONTENT_SUCCESS';
export const FETCH_PLAN_CONTENT_FAILURE = 'FETCH_PLAN_CONTENT_FAILURE';

// Action Creators
export const fetchPlanContentRequest = () => ({
    type: FETCH_PLAN_CONTENT_REQUEST
});

export const fetchPlanContentSuccess = (content) => ({
    type: FETCH_PLAN_CONTENT_SUCCESS,
    payload: content
});

export const fetchPlanContentFailure = (error) => ({
    type: FETCH_PLAN_CONTENT_FAILURE,
    payload: error
});

// Async Action to fetch plan content
export const fetchPlanContent = () => {
    return async (dispatch) => {
        dispatch(fetchPlanContentRequest());

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Baseurl}/Front-End/site/plan-content-subscription`
            );

            if (response?.data?.status) {
                dispatch(fetchPlanContentSuccess(response.data.data));
            } else {
                dispatch(fetchPlanContentFailure('Failed to fetch plan content'));
            }
        } catch (error) {
            dispatch(fetchPlanContentFailure(
                error?.response?.data?.message || error.message || 'Failed to fetch plan content'
            ));
        }
    };
};
